const WITH_RX = 'with-rx';
const WITHOUT_RX = 'without-rx';

export { WITHOUT_RX, WITH_RX };
//# sourceMappingURL=types.js.map
